module.exports = __webpack_public_path__ + "static/media/ic-itinerary.c8026075.svg";